import { useContext } from 'react';
import { useLocalStore } from 'mobx-react';
import { AppService } from '@ibe/services';
import { AppContext } from './Contexts';

function useCurrency(): {
  currencyCode: string;
  setCurrencyCode: (currencyCode: string) => void;
} {
  const context = useContext(AppContext);
  const appService = useLocalStore<AppService>(() => context);

  return {
    currencyCode: appService.currency,
    setCurrencyCode: (code: string): Promise<void> => {
      return appService.setCurrency(code);
    }
  };
}

export default useCurrency;
